<template>
  <div>
    <div class="pt-1">
      <div v-if="currentCard.actionType === 'LINK'">
        <a
            @click="trackActionLink"
            :href="validateActionLink(currentCard)"
            class="action-lnk get-started-link"
            :target="validateOpenInNewTab(currentCard)"
        >
          <span class="card-link">Click here</span>
          <span class="pl-1">
            <font-awesome-layers class="fa-md get-started-chevron">
              <font-awesome-icon icon="circle"/>
              <font-awesome-icon
                  icon="chevron-right"
                  transform="shrink-8"
                  :style="{ color: 'white' }"
              />
            </font-awesome-layers>
          </span>
        </a>
      </div>
      <div v-else>
        <a @click="openSolutionModal(currentCard)" class="action-lnk get-started-link">
          <span class="card-link">Click here</span>
          <span class="pl-1" style="vertical-align: text-top">
            <font-awesome-layers class="fa-md get-started-chevron">
              <font-awesome-icon icon="circle"/>
              <font-awesome-icon
                  icon="chevron-right"
                  transform="shrink-8"
                  :style="{ color: 'white' }"
              />
            </font-awesome-layers>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CardHelperMixin from "@/components/homepage/mixins/CardHelperMixin";
import MixpanelMixin from "@/mixins/MixpanelMixin";
import Constants from "../../store/constants";
import CategoriesModal from "@/components/CategoriesModal";
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters([
      "currentAppData",
    ]),
  },
  mixins: [CardHelperMixin, MixpanelMixin],
  methods: {
    trackActionLink() {
      this.trackFeatureSelected(
          this.currentAppData.name,
          this.currentCard.name,
          "Click here",
          this.currentCard.actionLink
      );
    },
    trackActionLinkModal() {
      this.trackFeatureSelected(
          this.currentAppData.name,
          this.currentCard.name,
          "Click here",
          "MODAL"
      );
    },
    openSolutionModal(currentCard) {
      this.trackActionLinkModal();

      let card = currentCard
      this.$modal.show(
          CategoriesModal,
          {card},
          {
            adaptive: true,
            maxWidth: 800,
            height: "auto",
            width: "100%",
            scrollable: true
          })

    },
    validateOpenInNewTab(currentCard) {
      return currentCard.actionLink.includes('http') ? '_blank' : null
    },
    validateActionLink(currentCard) {
      return currentCard.actionLink.includes('http') ? currentCard.actionLink :
          Constants.EH_URL + currentCard.actionLink;
    }
  },
};
</script>
<style scoped>
.get-started-link {
  display: flex;
  align-items: center;
  font-size: 14px !important;
  font-family: artifaktElementRegular !important;
}

.get-started-chevron {
  display: flex;
  align-self: center;
  color: black !important;
}
</style>
